import React, { useEffect, useState } from "react";
import "./AdminPage.css";
import Button from "@mui/material/Button";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import { Stack } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { addUser, getUsers } from "../function-components/Redux/UsersSlice";
import { setNewUser } from "../function-components/Redux/UsersSlice";
import TablePagination from "@mui/material/TablePagination";
import * as XLSX from "xlsx/xlsx.mjs";
import Alert from "@mui/material/Alert";

function createData(SNo, Enterprise_ID, Action) {
  return { SNo, Enterprise_ID, Action };
}

function AdminPage() {
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [deleteEntId, setDeleteEntId] = useState("");
  const [deleteSuccess, setDeleteSuccess] = useState(false);

  const [open, setOpen] = React.useState(false);
  // const [newUser, setNewUser] = useState("");
  // const usersData = useSelector((state) => state.users.usersData.map((item, i) => ({...item, id: i+1})));
  const usersData = useSelector((state) => state.users.usersData);
  const dispatch = useDispatch();
  const [newId, setNewId] = useState("");
  const [isUserNameNull, setIsUserNameNull] = useState(false);

  const updateStatus = useSelector((state) => state.users.updateStatus);
  const [isDuplicateUser, setIsDuplicateUser] = useState(false);
  const [isAddUserOpen, setIsAddUserOpen] = useState(false);
  const [isUserAddedSuccess, setIsUserAddedSuccess] = useState(false);

  const [searchVal, setSearchVal] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);
  const PER_PAGE = rowsPerPage;
  const startIdx = page * PER_PAGE; // 0 5 10 15

  const statusError = useSelector((state) => state.users.error);

  let count = 1;
  const [finalDownload, setFinalDownload] = useState(usersData);

  // const [sno, setSno] = useState(count);

  // const allowedUsers = usersData.map((item) => item.EnterpriseID);

  const baseURL = "https://atci.lkm.eitacademy.accenture.com/ips-apis";

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setIsAddUserOpen(false);
    setIsDuplicateUser(false);
    setIsUserAddedSuccess(false);
    setNewId("");
  };

  const handleClickDeleteOpen = (entId) => {
    setDeleteOpen(true);
    setDeleteEntId(entId);
    console.log("clickDeleteOpen");
    console.log(entId, "entId in clickdeleteopen");
  };
  const handleDeleteClose = () => {
    setDeleteOpen(false);
  };

  const ColorButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText("#3653ff"),
    backgroundColor: "#003cde",
    marginLeft: "5%",
    "&:hover": {
      backgroundColor: "#003cde",
      color: "#fff",
    },
  }));

  const handleSubmit = () => {
    if (newId == "") {
      setIsUserNameNull(true);
      setIsAddUserOpen(true);
    }

    if (newId != "") {
      dispatch(addUser(newId));
      setIsUserNameNull(false);
      setNewId("");
      setIsUserAddedSuccess(true);
    }
  };

  const saveDeleteHandle = () => {
    // deleteEnterpriseID(deleteEntId);
    // setBoolCheckedDelete(true);
    console.log(deleteEntId, "inside saveDeleteHandle");
    deleteEnterpriseID(deleteEntId);
    setDeleteOpen(false);
    setSearchVal("");
    // dispatch(getUsers());
    setDeleteSuccess(!deleteSuccess);
  };

  useEffect(() => {
    console.log(usersData, "first inst");
    dispatch(getUsers());
    console.log(deleteSuccess, "delete success in useEffect");
  }, [deleteSuccess, isUserAddedSuccess]);

  const deleteEnterpriseID = (entId) => {
    console.log(entId, "in the axios delete");
    axios
      .delete(`${baseURL}/deleteUser/${entId}`, {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        setDeleteSuccess(!deleteSuccess);
        dispatch(getUsers());
        console.log("delete successfull!", res.data);
      })
      .catch((err) => {
        console.error("ERRORRR is", err);
      });
  };

  const searchFunction = (e) => {
    setSearchVal(e.target.value);
    setPage(0);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // useEffect(() => {
  //     // let finalDownload = Array.from(usersData);
  //     finalDownload.forEach((element) => {
  //         element.id = count++;
  //     });
  //     console.log(finalDownload, "finallll");
  // }, [usersData])

  function handleDownload() {
    const worksheet = XLSX.utils.json_to_sheet(finalDownload);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Users");
    XLSX.writeFile(workbook, "E&IT-User-list.xlsx");
  }

  useEffect(() => {
    setFilteredData(usersData);
    setFinalDownload(usersData.map((item, i) => ({ Sno: i + 1, ...item })));
    console.log("new useEffecttt");
  }, [usersData, deleteSuccess]);

  useEffect(() => {
    // let finalData = usersData.map((item)=> ({...item}));
    // finalData = finalData.map((item) => item.sno = count++)
    // let finalData = JSON.parse(JSON.stringify(usersData))
    // Object.preventExtensions(finalData);
    // setFilteredData(finalData);
    // console.log(finalData, "final data");
    // console.log(Object.isExtensible(finalData), "hoho");
    // console.log(Object.isExtensible(usersData), "hehe");

    setFilteredData(
      usersData?.filter((item) =>
        Object.values(item).some(
          (val) =>
            typeof val === "string" &&
            val.toLowerCase().includes(searchVal.toLowerCase()),
        ),
      ),
    );
    // setFilteredData(
    // let abc = usersData?.filter((item) =>
    //     item.EnterpriseID === "aayushi.bharti"
    // )
    // console.log(abc, "abc");
    // );
    // setFilteredDome(true);
  }, [searchVal, usersData]);

  return (
    <>
      <div className="banner-container">
        <img
          src="images/UserMaintenance/Banner.png"
          alt="banner-img"
          className="banner"
        />
        <h1>User Maintenance Screen</h1>
      </div>
      <div className="heading-block">
        <h2>User Maintenance</h2>
        <p>
          User Maintenance screen is a vital tool for managing user account
          efficiently. It simplifies role-assignments, streamlining
          administrative tasks with its user friendly interface, it ensures
          seamless user management for enhanced system security and
          functionality.
        </p>
      </div>
      {statusError && (
        <Alert severity="error" className="errorAlert">
          <b>Internal Server Error:</b> Please try again with a hard refresh. If
          the issue persists, contact the LIS team for further assistance.
        </Alert>
      )}
      <br></br>
      <div className="search-container">
        <div className="search-inner-container">
          <TextField
            className="search-box"
            onChange={searchFunction}
            value={searchVal}
            sx={{ m: 1, width: "30ch", align: "center" }}
            placeholder="Search by Enterprise ID..."
          ></TextField>
          <img
            src="images/UserMaintenance/search-icon.png"
            alt="search-icon"
            className="search-icon"
          />
        </div>
        <div className="download-container">
          <ColorButton
            variant="contained"
            onClick={handleDownload}
            className="add-user"
          >
            Download
          </ColorButton>
          <ColorButton
            variant="contained"
            onClick={handleClickOpen}
            className="add-user"
          >
            Add User
          </ColorButton>
        </div>
      </div>

      <div className="table-container">
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table" fullWidth>
            <TableHead>
              <TableRow>
                <TableCell>
                  Sl. #<span className="borderRight"></span>
                </TableCell>

                <TableCell align="left">
                  Enterprise ID<span className="borderRight"></span>
                </TableCell>
                <TableCell align="left">Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredData != undefined &&
                filteredData.length != 0 &&
                filteredData
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .filter((item) =>
                    item.Enterprise_ID?.toLowerCase().includes(
                      searchVal.toLowerCase(),
                    ),
                  )
                  .map((row, i) => (
                    <TableRow
                      key={i}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        {startIdx + i + 1}{" "}
                        <span className="borderRight-gray"></span>
                      </TableCell>
                      <TableCell align="left" sx={{ color: "#6c6c6c" }}>
                        {row.Enterprise_ID}
                        <span className="borderRight-gray"></span>
                      </TableCell>
                      <TableCell
                        align="left"
                        onClick={() => handleClickDeleteOpen(row.Enterprise_ID)}
                      >
                        <img
                          src="images/UserMaintenance/delete-icon.png"
                          alt="delete-icon"
                          className="delete-icon"
                        />
                      </TableCell>
                    </TableRow>
                  ))}
            </TableBody>
          </Table>
        </TableContainer>
        {/* <div style={{ marginBottom: "4%" }}>
                    <Stack justifyContent={"center"} spacing={2} direction={"row"}>
                        <ColorButton
                            variant="contained"
                            size="small"
                        // autoFocus
                        // onClick={handleSubmitClick}
                        >
                            Submit
                        </ColorButton>
                        <ColorButton
                            variant="contained"
                            size="small"
                        // autoFocus
                        // onClick={handleDownload}
                        >
                            Download
                        </ColorButton>
                    </Stack>
                </div> */}
      </div>

      <div className="modal-container">
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title" className="addUser-title-dialog">
            {"Add User"}
          </DialogTitle>
          {!isDuplicateUser && !isUserAddedSuccess ? (
            <DialogContent>
              <Stack sx={{ padding: "10px", marginTop: "10px" }} spacing={2}>
                <Stack
                  spacing={1}
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "1fr 3fr",
                    alignItems: "center",
                    gap: "1rem",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "14px",
                      color: "#000000",
                      fontFamily: "graphik-medium !important",
                    }}
                  >
                    Enterprise ID:
                    <span style={{ color: "#A80011" }}>*</span>
                  </Typography>
                  <TextField
                    error={isUserNameNull && isAddUserOpen ? true : false}
                    required={isUserNameNull && isAddUserOpen ? false : true}
                    className="coursecode-textfield"
                    size="small"
                    value={newId}
                    fullWidth
                    multiline
                    placeholder="Eg: aayushi.bharti"
                    id={
                      isUserNameNull && isAddUserOpen
                        ? "outlined-error"
                        : "outlined-required"
                    }
                    variant="outlined"
                    helperText={
                      isUserNameNull && isAddUserOpen
                        ? "Please enter the user name"
                        : null
                    }
                    onChange={(e) => {
                      setNewId(e.target.value);
                      if (newId !== "") {
                        setIsUserNameNull(false);
                      }
                    }}
                    sx={{ width: "100%", fontSize: "14px !important" }}
                  />
                </Stack>
              </Stack>
            </DialogContent>
          ) : updateStatus === "error" && isUserAddedSuccess ? (
            <DialogContent
              sx={{ paddingTop: "15px", paddingBottom: "15px", width: "600px" }}
            >
              {console.log(isUserAddedSuccess, " Server Error  ")}
              <Stack
                sx={{ padding: "10px", marginTop: "10px" }}
                spacing={2}
              ></Stack>
              <Typography
                sx={{ fontSize: "14px", textAlign: "center", color: "red" }}
              >
                SERVER ERROR !! TRY AGAIN AFTER SOMETIME !!!
              </Typography>
            </DialogContent>
          ) : isUserAddedSuccess &&
            updateStatus != "duplicate" &&
            updateStatus != "error" ? (
            <DialogContent
              sx={{ paddingTop: "15px", paddingBottom: "15px", width: "600px" }}
            >
              {console.log(
                isUserAddedSuccess,
                " is User Added Successfully ! ",
              )}
              <Stack
                sx={{ padding: "10px", marginTop: "10px" }}
                spacing={2}
              ></Stack>
              <Typography sx={{ fontSize: "14px", textAlign: "center" }}>
                User Added Successfully!
              </Typography>
            </DialogContent>
          ) : updateStatus === "duplicate" ? (
            <DialogContent
              sx={{ paddingTop: "15px", paddingBottom: "15px", width: "600px" }}
            >
              <Stack
                sx={{ padding: "10px", marginTop: "10px" }}
                spacing={2}
              ></Stack>
              <Typography sx={{ fontSize: "14px", textAlign: "center" }}>
                The user has already got access!
              </Typography>
            </DialogContent>
          ) : null}
          {!isDuplicateUser && !isUserAddedSuccess ? (
            <DialogActions
              sx={{
                justifyContent: "center",
                alignItems: "center",
                marginBottom: "10px",
              }}
            >
              <ColorButton
                variant="contained"
                className="save-button"
                size="small"
                sx={{ background: "#003cde", color: "white" }}
                // autoFocus
                onClick={handleSubmit}
              >
                Submit
              </ColorButton>
              <ColorButton
                variant="contained"
                className="cancel-button"
                size="small"
                sx={{
                  background: "white",
                  color: "#003cde",
                  border: "solid 1px #003cde",
                }}
                // autoFocus
                onClick={handleClose}
              >
                Cancel
              </ColorButton>
            </DialogActions>
          ) : (
            <DialogActions
              sx={{
                justifyContent: "center",
                alignItems: "center",
                marginBottom: "10px",
              }}
            >
              <ColorButton
                variant="contained"
                className="cancel-button"
                size="small"
                sx={{
                  background: "white",
                  color: "#3653ff",
                  border: "solid 1px #3653ff",
                }}
                autoFocus
                onClick={handleClose}
              >
                Ok
              </ColorButton>
            </DialogActions>
          )}
        </Dialog>
      </div>

      <div className="delete-modal-container">
        <Dialog
          open={deleteOpen}
          onClose={handleDeleteClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title" className="deleteUser-dialog">
            {"Delete User"}
          </DialogTitle>
          <DialogContent sx={{ borderBottom: "1px solid lightgray" }}>
            <DialogContentText
              id="alert-dialog-description"
              className="deleteUser-content"
            >
              Are you sure you want to delete this user?
            </DialogContentText>
          </DialogContent>
          <DialogActions
            sx={{
              justifyContent: "center",
              alignItems: "center",
              marginBottom: "10px",
              marginTop: "5px",
            }}
          >
            <ColorButton
              variant="contained"
              className="red-button"
              size="small"
              sx={{ background: "red", color: "white", width: "4rem" }}
              autoFocus
              onClick={() => saveDeleteHandle()}
            >
              Yes
            </ColorButton>
            <ColorButton
              variant="contained"
              className="cancel-button"
              size="small"
              sx={{
                background: "white",
                color: "gray",
                border: "solid 1px gray",
                width: "4rem",
              }}
              autoFocus
              onClick={handleDeleteClose}
            >
              No
            </ColorButton>
          </DialogActions>
        </Dialog>
      </div>

      <TablePagination
        rowsPerPageOptions={[5, 15, 30]}
        component="div"
        count={filteredData.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        className="table-pagination"
      />
      <br />
      <br />
      <br />

      {/* <hr /> */}
    </>
  );
}

export default AdminPage;
